// Mock functions for testing
let _gettext = window.gettext;
if (!_gettext) _gettext = (string) => string;

let _pgettext = window.pgettext;
if (!_pgettext) _pgettext = (part, string) => part;

export const gettext = _gettext;
export const jsts = window.jsts;
export const $ = window.$;
export const interpolate = window.interpolate;
export const _ = window._;
export const pgettext = _pgettext;
export const Model = window.Model;
export const View = window.View;
export const OpenLayers = window.OpenLayers;
export const Cropr = window.Cropr;
// eslint-disable-next-line camelcase
export const js_settings = window.js_settings;
